import cn from 'classnames';
import { useRef } from 'react';
import { getObjectValue } from '@services/object-extensions';
import styles from './accordion.module.css';
import SVG from '@svg/chevron-up.svg';

const Accordion = ({
  head,
  open,
  setOpen,
  children,
  Icon = SVG,
  iconColor = 'black',
  darkTheme = false,
  backgroundColor = 'rgba(0, 124, 196, 0.15)'
}) => {
  const forwardReference = useRef();
  const buttonReference = useRef();

  const bodyMaxHeight = open
    ? `${getObjectValue(forwardReference, 'current.scrollHeight', '10000')}px`
    : '0px';

  return (
    <>
      <div
        className={styles.wrapper}
        style={{
          '--accordion-body-max-height': bodyMaxHeight,
          '--accordion-border-color': darkTheme ? 'white' : 'black',
          '--accordion-icon-color': iconColor,
          '--accordion-bg': backgroundColor
        }}
      >
        <button
          className={`${styles.button} justify-content-between no-gutters`}
          onClick={() => setOpen(!open)}
          type="button"
          ref={buttonReference}
        >
          <div className={`row w-100 justify-content-between no-gutters ${styles.borderBottom}`}>
            <div
              className={cn(
                'col-10 col-md-auto snf-font-16 snf-font-sm-18 text-truncate snf-font-w6 snf-color-black text-left',
                {
                  'snf-color-white': darkTheme
                }
              )}
            >
              {head}
            </div>
            <div className={cn('col-auto ', { [styles.acccordionClose]: !open })}>
              <Icon className={styles.icon} />
            </div>
          </div>
        </button>
        <div className={styles.body} ref={forwardReference}>
          <div>{children}</div>
        </div>
      </div>
    </>
  );
};

Accordion.displayName = 'Accordion';
export { Accordion };
